/**
 * hotdeal.js — trang deal hàng tháng (hotdeal.html).
 *   1. Lọc + sắp xếp lưới deal: chip [data-deal-filter] (aria-pressed), select [data-deal-sort],
 *      thẻ [data-deal][data-deal-tags][data-deal-pct][data-deal-sold][data-price], số đếm [data-deal-count],
 *      dòng trống [data-deal-empty]. Lọc trên trình duyệt vì một đợt chỉ ~30 deal — đổi nhóm không tải lại trang.
 *   2. Chép mã giảm giá: đã tách sang js/copy-code.js (popup khuyến mãi ở footer cũng cần — mọi trang).
 *   3. Thêm combo: button[data-combo-add='[{id, price, regular, qty?, variant?}]'] → mỗi món một dòng giỏ
 *      với đúng giá combo (WBStore.product lấy tên / ảnh từ catalog, giá ghi đè từ dữ liệu combo).
 *   4. "Nhắc tôi": button[data-deal-remind] bật / tắt (aria-pressed), nhớ trên máy, báo toast.
 *   5. Nút "Xem khung đang diễn ra" trong khung flash đã qua: [data-flash-goto="id tab"] bấm hộ tab đó.
 *
 * WP: giữ phần 1, 5. Phần 3 đổi sang AJAX woocommerce_add_to_cart; phần 4 (DEMO) POST đăng ký nhắc
 * (user meta / Zalo OA) thay vì localStorage.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var page = document.querySelector('[data-hotdeal]');
    if (!page) return;

    function toast(message) {
        if (window.WBToast) window.WBToast.show(message);
    }

    // ----- 1. Lọc + sắp xếp -----
    var grid = page.querySelector('[data-deal-grid]');
    var cards = grid ? [].slice.call(grid.querySelectorAll('[data-deal]')) : [];
    var chips = [].slice.call(page.querySelectorAll('[data-deal-filters] [data-deal-filter]'));
    var sort = page.querySelector('[data-deal-sort]');
    var count = page.querySelector('[data-deal-count]');
    var empty = page.querySelector('[data-deal-empty]');
    var current = 'all';

    function num(card, attr) {
        return Number(card.getAttribute(attr)) || 0;
    }

    var sorters = {
        pct: function (a, b) {
            return num(b, 'data-deal-pct') - num(a, 'data-deal-pct');
        },
        sold: function (a, b) {
            return num(b, 'data-deal-sold') - num(a, 'data-deal-sold');
        },
        'price-asc': function (a, b) {
            return num(a, 'data-price') - num(b, 'data-price');
        },
        'price-desc': function (a, b) {
            return num(b, 'data-price') - num(a, 'data-price');
        }
    };

    function apply() {
        var shown = 0;
        cards.forEach(function (card) {
            var tags = ' ' + (card.getAttribute('data-deal-tags') || '') + ' ';
            var match = current === 'all' || tags.indexOf(' ' + current + ' ') !== -1;
            card.hidden = !match;
            if (match) shown += 1;
        });

        // Sắp lại bằng appendChild theo thứ tự mới — thẻ ẩn đi theo, không sao
        var by = sorters[sort ? sort.value : 'pct'] || sorters.pct;
        cards.slice().sort(by).forEach(function (card) {
            grid.appendChild(card);
        });

        chips.forEach(function (chip) {
            chip.setAttribute('aria-pressed', chip.getAttribute('data-deal-filter') === current ? 'true' : 'false');
        });
        if (count) count.textContent = shown;
        if (empty) empty.hidden = shown > 0;
    }

    if (grid && cards.length) {
        // Cả chip trong thanh lọc lẫn nút "xem tất cả deal" ở dòng trống
        page.addEventListener('click', function (event) {
            var trigger = event.target.closest ? event.target.closest('[data-deal-filter]') : null;
            if (!trigger) return;
            current = trigger.getAttribute('data-deal-filter');
            apply();
        });
        if (sort) sort.addEventListener('change', apply);
        apply();
    }

    // ----- 3. Thêm combo vào giỏ -----
    page.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-combo-add]') : null;
        if (!button || !window.WBStore) return;
        var items;
        try {
            items = JSON.parse(button.getAttribute('data-combo-add'));
        } catch (e) {
            return;
        }
        items.forEach(function (item) {
            var snap = window.WBStore.product(item.id, null);
            if (!snap) return;
            snap.price = item.price;
            snap.regularPrice = item.regular || item.price;
            if (item.variant) snap.variant = item.variant;
            window.WBStore.cart.add(snap, item.qty || 1);
        });
        toast('Đã thêm combo “' + (button.getAttribute('data-combo-name') || '') + '” vào giỏ hàng');
    });

    // ----- 4. Nhắc tôi (DEMO) -----
    var KEY = 'wb_deal_remind';

    function readReminders() {
        try {
            return JSON.parse(window.localStorage.getItem(KEY)) || [];
        } catch (e) {
            return [];
        }
    }

    function paintRemind(button, on) {
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        var label = button.querySelector('span');
        var icon = button.querySelector('i');
        if (label) {
            if (!button._label) button._label = label.textContent;
            label.textContent = on ? 'Đã đặt nhắc' : button._label;
        }
        if (icon) icon.className = on ? 'ph-fill ph-bell-ringing' : 'ph-bold ph-bell';
    }

    var reminders = readReminders();
    [].slice.call(page.querySelectorAll('[data-deal-remind]')).forEach(function (button) {
        if (reminders.indexOf(button.getAttribute('data-deal-remind')) !== -1) paintRemind(button, true);
    });

    page.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-deal-remind]') : null;
        if (!button) return;
        var id = button.getAttribute('data-deal-remind');
        var list = readReminders();
        var on = list.indexOf(id) === -1;
        list = list.filter(function (x) {
            return x !== id;
        });
        if (on) list.push(id);
        try {
            window.localStorage.setItem(KEY, JSON.stringify(list));
        } catch (e) {
            // Chế độ ẩn danh: vẫn đổi trạng thái nút, chỉ không nhớ được lần sau
        }
        paintRemind(button, on);
        toast(on ? 'Đã đặt nhắc — WINEBOSS báo bạn khi deal mở' : 'Đã huỷ nhắc deal này');
    });

    // ----- 5. Khung flash đã qua → chuyển sang khung đang diễn ra -----
    page.addEventListener('click', function (event) {
        var link = event.target.closest ? event.target.closest('[data-flash-goto]') : null;
        if (!link) return;
        var tab = document.getElementById(link.getAttribute('data-flash-goto'));
        if (!tab) return;
        event.preventDefault();
        tab.click();
        tab.focus();
    });
})();
